import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import type { sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer$key } from '@atlassian/jira-relay/src/__generated__/sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer.graphql';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { ServiceEntityMain } from './main.tsx';
import type { ServiceEntityFragmentRendererProps } from './types.tsx';

const ServiceEntityFragmentRenderer = (props: ServiceEntityFragmentRendererProps) => {
	const { fragmentKey, area, projectKey, onChange } = props;

	const data = useFragment<sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer on JiraAffectedServicesField {
				fieldId @required(action: THROW)
				selectedAffectedServicesConnection @required(action: NONE) {
					edges @required(action: NONE) {
						node @required(action: NONE) {
							serviceId @required(action: NONE)
							name @required(action: NONE)
						}
					}
				}
			}
		`,
		fragmentKey,
	);

	if (!data) {
		return null;
	}

	const affectedServices = data.selectedAffectedServicesConnection.edges;
	const initialServices =
		affectedServices
			.map((edge) => {
				const name = edge?.node.name;
				const id = edge?.node.serviceId;

				if (!name || !id) {
					return null;
				}
				return {
					data: {
						id,
						name,
					},
					id,
					name,
				};
			})
			.filter((value) => value != null) ?? [];

	const sortedInitialServices = initialServices.sort((a, b) => a.name.localeCompare(b.name));

	return (
		<ErrorBoundary id="field-service-entity" packageName="jira-issue-field-service-entity">
			<Placeholder name="service-entity-field" fallback={<></>}>
				<ServiceEntityMain
					initialServices={sortedInitialServices}
					fieldId={data.fieldId}
					projectKey={projectKey}
					onChange={onChange}
					area={area}
				/>
			</Placeholder>
		</ErrorBoundary>
	);
};

export default ServiceEntityFragmentRenderer;
